import { makeStyles, Theme } from '@freighthub/silhouette-core'
import classnames from 'classnames'
import { FC } from 'react'

interface ProgressTrackableObjectProps {
  title: string
  progress?: number
  inCircle?: boolean
}

type StyleProps = Pick<ProgressTrackableObjectProps, 'progress'>

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  progressTrackableObject: {
    height: 60,
    position: 'absolute',
    bottom: 0,
    top: 'auto',
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    left: ({ progress }) => `${progress}%`,
  },
  progressTrackableObjectInCircle: {
    bottom: '100%',
    marginBottom: theme.spacing(1),
    transform: 'translateY(19px)',
    left: '50%',
  },
  progressTrackableObjectLine: {
    height: '100%',
    borderLeft: `1px dashed ${theme.palette.divider}`,
  },
  progressTrackableObjectTitle: {
    position: 'absolute',
    bottom: '100%',
    transform: 'translateX(-50%)',
    width: 200,
    textAlign: 'center',
  },
}))

export const ProgressTrackableObject: FC<ProgressTrackableObjectProps> = ({ progress, inCircle, title }) => {
  const classes = useStyles({ progress })
  return (
    <div
      className={classnames(classes.progressTrackableObject, { [classes.progressTrackableObjectInCircle]: inCircle })}
    >
      <div className={classes.progressTrackableObjectLine} />
      <div className={classes.progressTrackableObjectTitle}>{title}</div>
    </div>
  )
}
